import { PageProps } from "../../models/routing.model";
import { Outlet } from "react-router-dom";

const HealthReport = (_props: PageProps) => {
	return <Outlet />;
};

export default HealthReport;
